// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"869e1e32","447":"ea0fc6ad","453":"38a80239","455":"5063ba1f","977":"e8b3ec01"}[chunkId] + ".chunk.js";
};